// extracted by mini-css-extract-plugin
export default {"timingData":"style_timingData__EoHt+"};